import { k } from "../kaplay"

export const theme = [
    {
        name : "classicCapy",
        paddleSprite : "capybara",
        background : "brick",
        color1 :  k.rgb(212, 53, 25),
        color2 : "#410a00",
        // noise : "noise1",
        bgm : "mus3"
    },
    {
        name : "blueSea",
        paddleSprite : "whale",
        background : "wave",
        color1 :  k.rgb(91, 87, 255),
        color2 : k.rgb(83, 82, 217),
        // noise : "noise2",
        bgm : "mus1"
    },
    {
        name : "greenFrog",
        paddleSprite : "frog",
        background : "circ",
        color1 : k.rgb(249, 212, 167),
        color2 : k.rgb(249, 212, 167),
        // noise : "noise3", 
        bgm : "mus2"
    },
    {
        name : "pinkAx",
        paddleSprite : "axolotl",
        background : "sprink",
        color1 :  k.rgb(255, 233, 241),
        color2 : k.rgb(253, 183, 217),
        // noise : "noise4", 
        bgm : "mus4"
    },
];